import { useState } from "react";

const faqItems = [
  {
    q: "Who offers vehicle storage near me in the Bay Area?",
    a: "Don Collins Auto Storage provides secure indoor vehicle storage in San Rafael and Point Richmond, CA. We serve clients across Marin County, the East Bay, and the greater Bay Area with fully-alarmed, professional indoor storage facilities.",
  },
  {
    q: "How much does indoor vehicle storage cost?",
    a: "Pricing depends on the vehicle type, storage duration, and current availability. We offer competitive rates with the best pricing available for long-term storage. Contact us directly at (415) 453-9180 for a current quote.",
  },
  {
    q: "Is climate-controlled storage necessary for my vehicle?",
    a: "Yes, especially in the Bay Area. Climate control helps prevent humidity damage, rust, degraded rubber seals, cracked interiors, and paint issues caused by temperature fluctuations. Our indoor environment provides year-round protection.",
  },
  {
    q: "What types of vehicles do you store?",
    a: "We store automobiles, motorcycles, RVs, boats, trucks, and specialty equipment. Our facilities accommodate everyday vehicles, classic cars, collectibles, and oversized equipment. Contact us to confirm space for your specific vehicle.",
  },
  {
    q: "Do you offer motorcycle transport or road service?",
    a: "Yes. Jim Long offers motorcycle road service and transport. If your motorcycle needs transport to our facility or assistance on the road, call (415) 846-4281.",
  },
  {
    q: "Are your storage facilities fully alarmed and secure?",
    a: "Yes. Both our San Rafael and Point Richmond facilities are fully alarmed with controlled indoor access. Your vehicle is protected from theft, weather, and vandalism inside our secure indoor environment.",
  },
  {
    q: "How do I start storing my vehicle with Don Collins?",
    a: "Simply call us at (415) 453-9180 or fill out the inquiry form on this page. Storage is by appointment — please call first. We'll confirm availability and arrange a convenient drop-off time for your vehicle.",
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section
      id="faq"
      className="bg-[#F8F8F8] py-24 lg:py-32"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            Voice Search Optimized
          </p>
          <h2 className="font-serif text-charcoal text-4xl lg:text-5xl font-bold mb-4">
            Frequently Asked Questions
          </h2>
          <p className="font-sans text-[#777] text-base">
            Everything you need to know about our indoor vehicle storage services.
          </p>
        </div>

        {/* Accordion */}
        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg border-l-2 border-l-transparent hover:border-l-gold transition-all duration-200 overflow-hidden shadow-sm"
              style={{ borderLeft: openIdx === idx ? "2px solid #D4AF37" : "" }}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <h3
                  className="font-sans text-charcoal text-base font-semibold pr-4 leading-snug"
                  itemProp="name"
                >
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`${
                      openIdx === idx ? "ri-subtract-line text-gold" : "ri-add-line text-gold"
                    } text-lg transition-all duration-200`}
                  ></i>
                </div>
              </button>
              {openIdx === idx && (
                <div
                  className="px-6 pb-5"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p
                    className="font-sans text-[#666] text-sm leading-relaxed"
                    itemProp="text"
                  >
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
